import React from 'react';

export default function Loading() {
  return <div style={{ textAlign: 'center' }}>Loading...</div>;
}
